import { createSlice } from "@reduxjs/toolkit";

const _initialState = {
  //altri campi dello stato dei gestisci documenti
  selectedDocsIds: [],
  tableFilters: {
    macroCategory: "",
    category: "",
    minAmount: "",
    maxAmount: "",
  },
};

// Slice instance

const documentManagementSlice = createSlice({
  name: "docManagementSlice", // REDUX Storage name
  initialState: _initialState,
  // Azioni meccaniche
  reducers: {
    setTableFilters: (state, action) => {
      state.tableFilters = action.payload;
    },

    setSelectedDocsIds: (state, action) => {
      state.selectedDocsIds = action.payload;
    },

  },

  //Azioni che interferiscono con il backend
  extraReducers: (builder) => { },
  // Other custom actions as needed
});

export default documentManagementSlice;
export const { name, reducer, actions } = documentManagementSlice;
